import storeModuleFactory from 'util/storeModule/storeModuleFactory';
import { transformResultsFromObjectSplitByVendor } from 'util/data';
import endpoints from 'config/endpoints';
import {TIMEOUT_STORE} from 'util/constants';

const
    name = 'awsInstanceTypes',
    exports = storeModuleFactory({
        name,
        endpoint:           endpoints.awsInstanceTypes.endpoint,
        timeout:            TIMEOUT_STORE.TIMEOUT_STORE_BIG,
        instanceEndpoint:   endpoints.awsInstanceTypes.instanceEndpoint,
        transformResultsFn: json => transformResultsFromObjectSplitByVendor(json.results, 'AWS')
    });

module.exports = exports;



// WEBPACK FOOTER //
// ./src/modules/store/awsInstanceTypes.js